<template>
  <div class="card">
    <div class="card-header pb-0 mb-2">
      <h6>{{ title }}</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :pagination-options="{
            enabled: true,
            mode: 'records',
          }"
          :search-options="{ enabled: true }"
          :line-numbers="true"
          :isLoading="isLoading"
          :orderBy="{
            column: 'remaining_day',
            ascending: false,
          }"
        >
          <template #table-row="props">
            <div
              v-if="
                props.column.field == 'line_display' ||
                props.column.field == 'ref_line_display'
              "
            >
              <span v-if="props.column.field == 'line_display'">
                <router-link
                  :to="{
                    name: 'user/detail',
                    params: { username: props?.row?.username },
                  }"
                  >{{ props.row.line_display ? props.row.line_display : 'ไม่มีบันทึกข้อมูล' }}</router-link
                >
              </span>
              <span v-if="props.column.field == 'ref_line_display'">
                <router-link
                v-if="props?.row?.ref_username"
                  :to="{
                    name: 'user/detail',
                    params: { username: props?.row?.ref_username },
                  }"
                  >{{ props?.row?.ref_line_display }}</router-link
                >
                <span v-else>{{ props?.row?.ref_line_display ?? '' }}</span>
              </span>

            </div>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "users-table",
  props: {
    title: {
      type: String,
      default: () => "Users table",
    },
    params: {
      type: Object,
      default: () => {
        return {
            search_criteria: {
                Status: 'All',
            },
        };
      },
    },
    rows: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
